import { TEntityOverride } from 'src/types'

const override: TEntityOverride = {
  global: {
    properties: {
      groups: {
        type: 'groups',
      },
      initialAgentsLocations: {
        hidden: true,
      },
      events: {
        hidden: true,
      },
    },
  },
}

export default override
